import * as actionTypes from "./actionTypes";


export const storeNeedAnalysisData = (payload) =>{
  //console.log(payload);
  return{
    type:actionTypes.FETCH_NEED_ANALYSIS_DATA,
    payload:payload,
  }
}

export const addRecommendedProducts = (payload) => {
    //console.log(payload);
    return {
      type: actionTypes.ADD_RECOMMENDED_PRODUCTS,
      payload: payload,
    };
  };

  export const deleteOldRecommendedProducts = () => {
    return {
      type: actionTypes.DELETE_OLD_RECOMMENDED_PRODUCTS,
    };
  };